import { isObject } from "lodash";

export const hasSomeTruthyValues = (value: unknown): boolean => {
  if (isObject(value)) {
    return Object.values(value as Record<string, unknown>).some(val =>
      hasSomeTruthyValues(val),
    );
  }

  return Boolean(value);
};
